<template lang="html">
  <div class="l-wrap--medium u-mt8">
    <div v-if="squads.length"
    v-cloak
    class="SquadListing">
      <span>Showing {{ squads.length }} results</span>
      <transition-group tag="ul" class="SquadListing-items" name="squad-listing">
        <li v-for="(squad, index) in sortedSquads" :key="squad._uid"
        class="SquadListing-items u-mt2">
          <squad-listing-item :squad="squad"></squad-listing-item>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
// Libraries
import { uniqueId, flattenDeep, shuffle } from "lodash";
import MapboxClient from "mapbox/lib/services/geocoding";
import lineDistance from "turf-line-distance";
// Components
import SquadListingItem from "../components/squad-listing-item";

const client = new MapboxClient(process.env.MAPBOX_ACCESS_TOKEN);

export default {
  components: {
    SquadListingItem
  },

  data: () => {
    return {
      hasDistance: false,
      squads: [
        {
          name: "Cool Kids",
          organization: "FIFA",
          firstName: "Tommy",
          lastName: "Callahan",
          email: "test@gmail.com",
          phone: "301-867-5309"
        }
      ]
    };
  },

  props: {
    query: "",
    geoLocation: null,
    bounds: {
      required: true,
      type: Array,
      default: [[-180, 20], [-30, 72]]
    },
    listingApiUrl: {
      required: true,
      type: String
    }
  },

  computed: {
    /**
     * Conditionally sort squad data
     * - checks for distances to be set and sort by them if available.
     * @return {array} squads - sorted by condition
     */
    sortedSquads() {
      if (this.hasDistance) {
        return _.orderBy(this.squads, ['distance']);
      } else {
        return this.squads
      }
    }
  },

  watch: {
    query(newVal, oldVal) {
      !!newVal && this.geocodeQuery(newVal)
    },
    geoLocation(newVal, oldVal) {
      let location;
      if (!!newVal) {
        location = typeof newVal === 'string' ? JSON.parse(newVal) : newVal;
      }
      !!newVal && this.geocodeUserLocation(location) // To skip geocoding users location
    }
  },

  /**
   * Request data from the API
   * Trigger initial geocode query if either query data variable is available
   */
  mounted() {
    const self = this;
    this.loading = true;
    self.$http.get(self.listingApiUrl).then(
      response => {
        // get body data
        response.body.squads.forEach((squad) => {
          squad._uid = uniqueId();
        })
        self.squads = response.body.squads;

        if (typeof self.query !== 'undefined' && self.query !== "") {
          self.geocodeQuery(self.query);
        } else if (self.geoLocation !== null) {
          self.geocodeUserLocation(typeof self.geoLocation === 'string' ? JSON.parse(self.geoLocation) : self.geoLocation);
        }
      },
      response => {
        console.warn(response);
        // error callback
      }
    );
  },

  methods: {

    /**
     * Query zipcode from query string
     * @param {object} location - geolocation coordinates passed to the search API
     * if results are found, their relative distances are calculated which is used
     * for order the results.
     */
    geocodeUserLocation(location) {
      if (typeof location === "undefined") {
        console.warn('Location value is not defined.')
        return false;
      }
      const self = this;
      // Browser API data doesn't match search API structure and needs reformatted
      location = {
        latitude: location.lat,
        longitude: location.lng

      };

      // Request results from Mapbox's Geocoder API
      // docs: https://github.com/mapbox/mapbox-sdk-js/blob/master/API.md#geocodereverse
      client
        .geocodeReverse(location, {
          types: "postcode"
        })
        .then(res => {
          const query = res.entity.query[0];
          const results = res.entity.features;
          if (results.length) {
            const firstResult = results[0];

            this.hasDistance = true;
            self.updateFuzzyDistances(firstResult.center);
          } else {
            console.warn("NO RESULTS");
            this.hasDistance = false;
            // self.setNoResults();
          }
        })
        .catch(err => {
          // FIXME: Need to handle errors
          console.log(err);
        });
    },

    /**
     * Generate distance between locations
     * @param {array} pos - coordinates for point to reference
     */
    updateFuzzyDistances(pos) {
      let updatedSquads = [];
      this.squads.forEach(squad => {
        const coordinates = [squad.longitude, squad.latitude];
        // Scaffold a GeoJSON object
        const line = {
          "type": "Feature",
          // "properties": {},
          "geometry": {
            "type": "LineString",
            "coordinates": [
              // longitude, latitude
              [pos[0], pos[1]],
              coordinates
            ]
          }
        };

        // Get the distance in miles
        const distance = lineDistance(line, 'miles');
        // Collect the current properties value on the marker model
        const roundedDistance = parseFloat(distance.toFixed(2));
        // Nested object are not directly observered by Vue so we we need to replace it with a clone
        // Alternatively, would could use a nested watcher
        updatedSquads.push(Object.assign({}, squad, { distance: roundedDistance }));
      });
      this.squads = updatedSquads;
    },

    /**
     * Search a location from query string
     * @param {string} query - address, keyword or zipcode used to query search API
     * if results are found, their relative distances are calculated which is used
     * for order the results.
     */
    geocodeQuery(query) {
      const self = this;
      // Request results from Mapbox's Geocoder API
      // docs: https://github.com/mapbox/mapbox-sdk-js/blob/master/API.md#geocodeforward
      client
        .geocodeForward(query, {
          bbox: flattenDeep(this.bounds),
          country: "US",
          types: "region,postcode,place,neighborhood"
        })
        .then(res => {
          const query = res.entity.query[0];
          const results = res.entity.features;

          // Has results
          if (results.length) {
            const firstResult = results[0];
            this.hasDistance = true;
            // Update data to include distance
            self.updateFuzzyDistances(firstResult.center);
          } else {
            console.warn("NO RESULTS");
            this.hasDistance = false;
            self.setNoResults();
          }
        })
        .catch(err => {
          // FIXME: Need to handle errors
          console.log(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// squad-listing.vue?33430464